import API from "@/utils/api";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        isFetchedClientCatalogGroups: false,
        clientCatalogGroups: [],
        savingInProgress: false,
    },
    getters: {
        getField, //vuex-map-fields
    },
    mutations: {
        updateField, //vuex-map-fields
    },
    actions: {
        async fetch({ commit, state, dispatch }, payload) {
            updateField(state, { path: "clientCatalogGroups", value: [] });
            updateField(state, { path: "isFetchedClientCatalogGroups", value: false });
            return API.get(`/client_catalog_groups?sait_code=${payload.sait_code}`)
                .then((response) => {
                    updateField(state, { path: "clientCatalogGroups", value: response.data.data });
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                })
                .finally(() => {
                    updateField(state, { path: "isFetchedClientCatalogGroups", value: true });
                });
        },
    },
};
